module.exports = __webpack_public_path__ + "static/media/MAN-LOGO.53133ad9.png";